export default __webpack_public_path__ + "static/media/fraudArmorHomeMainBg.1689de46.jpg";